import React, { FormEvent, useState } from 'react';
import { Button, FormControl, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { gql, useMutation } from '@apollo/client';
import { compose, withProps } from 'recompose';
// @ts-ignore
import PhoneInput from '@/se/components/inputs/PhoneInput';
// @ts-ignore
import TextInput from '@/se/components/inputs/TextInput';
import { withLabel } from '@/se/components/Label';

interface CaretakerPhoneFormProps {
  procedureId: number;
  onDone: () => void;
}

const CaretakerPhoneForm = ({ procedureId, onDone }: CaretakerPhoneFormProps) => {
  const [caretakerName, setCaretakerName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const [setCaretakerPhone, { loading: busy }] = useMutation(gql`
    mutation setCaretakerPhone($procedureId: Long!, $phoneNumber: String!, $caretakerName: String) {
      setCaretakerPhone(procedureId: $procedureId, phoneNumber: $phoneNumber, caretakerName: $caretakerName)
    }
  `);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      await setCaretakerPhone({
        variables: {
          procedureId,
          phoneNumber,
          caretakerName: caretakerName.trim() || null,
        },
      });
      onDone();
    } catch (e) {
      console.error(e);
    }
  };

  const handleReset = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onDone();
  };

  return (
    <Box textAlign="center" display="flex" flexDirection="column" justifyContent="middle" maxWidth="62ch">
      <Typography variant="h5" gutterBottom>
        Caretaker Info
      </Typography>
      <Typography gutterBottom>
        Please enter the name and phone number of the person taking care of you today.
      </Typography>
      <Box
        flexDirection="column"
        component="form"
        onSubmit={handleSubmit}
        onReset={handleReset}
        display="flex"
        justifyContent="center"
        textAlign="left"
        mt={2}
      >
        <FormControl variant="outlined" style={{ flex: 3, marginBottom: 16 }}>
          <CaretakerNameInput
            value={caretakerName}
            onChange={(value: string) => setCaretakerName(value)}
            isDisabled={busy}
          />
        </FormControl>
        <FormControl variant="outlined" style={{ flex: 3 }}>
          <PhoneNumberInput value={phoneNumber} onChange={value => setPhoneNumber(value.trim())} disabled={busy} />
        </FormControl>
        <Box display="flex" flexDirection="column">
          <Button size="large" type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Box>
        <Box display="flex" flexDirection="column">
          <Button size="large" type="reset" variant="text" color="secondary">
            Skip
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CaretakerPhoneForm;

const CaretakerNameInput = compose(
  withLabel('Caretaker Name'),
  withProps({ placeholder: 'e.g., Mary Smith', maxLength: 120, autocomplete: false })
)(TextInput);

const PhoneNumberInput = compose(
  withLabel('Caretaker Phone Number'),
  withProps({ placeholder: 'e.g., (619) 412-9512' })
)(PhoneInput);
